// extracted by mini-css-extract-plugin
export var name = "name-module--name--MsWah";